// FriendsBottomBar — iter110.
//
// Two-row bottom bar used exclusively on /friends.
//   • Row 1 — page-specific actions (Add Friend / My QR).
//   • Thin 0.5px separator at #1a1a1a.
//   • Row 2 — the standard 5-tab BottomNav rendered in `bare` mode.
//
// Sits as a fixed element at the bottom of the viewport, matching the
// look of MapBottomBar (`background: #0d0d0d`, gold-tinted top border).
import { Camera, QrCode } from "lucide-react";
import { BottomNav } from "./BottomNav";
import { useI18n } from "../lib/i18n";

export default function FriendsBottomBar({ onAddFriend, onShowMyQr }) {
  const { t } = useI18n();
  return (
    <nav
      data-testid="friends-bottom-bar"
      className="fixed bottom-0 inset-x-0"
      style={{
        background: "#0d0d0d",
        borderTop: "0.5px solid rgba(232,184,75,0.2)",
        paddingBottom: "env(safe-area-inset-bottom, 0)",
        zIndex: 20,
      }}
    >
      <div style={{ padding: "8px 10px 6px", display: "flex", gap: 8 }}>
        <button
          type="button"
          data-testid="friends-bar-add"
          onClick={onAddFriend}
          className="inline-flex items-center justify-center gap-1.5 transition-opacity hover:opacity-95"
          style={{
            flex: 1,
            height: 38,
            background: "linear-gradient(135deg, #d4b25a 0%, #E8B84B 100%)",
            color: "#0B0B0B",
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: "0.02em",
            borderRadius: 9,
            border: "none",
            padding: "0 12px",
            minWidth: 0,
          }}
        >
          <Camera className="w-4 h-4 shrink-0" strokeWidth={2} />
          <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {t("friends_bar_add")}
          </span>
        </button>
        <button
          type="button"
          data-testid="friends-bar-my-qr"
          onClick={onShowMyQr}
          className="inline-flex items-center justify-center gap-1.5 transition-colors hover:bg-white/[0.04]"
          style={{
            flex: 1,
            height: 38,
            background: "transparent",
            color: "#E8B84B",
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: "0.02em",
            borderRadius: 9,
            border: "1.5px solid rgba(232,184,75,0.55)",
            padding: "0 12px",
            minWidth: 0,
          }}
        >
          <QrCode className="w-4 h-4 shrink-0" strokeWidth={2} />
          <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {t("friends_bar_my_qr")}
          </span>
        </button>
      </div>
      <div style={{ height: 0.5, background: "#1a1a1a", margin: "0 10px" }} aria-hidden />
      <BottomNav bare />
    </nav>
  );
}
